import React, { useCallback } from 'react'

import Image from 'next/image'

import { SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Column, Loader, Row } from 'Components/UI'

import { BackgroundImage } from 'Assets/Images/Sections/SubmitScoreboardFormSection'

import { HubSpotFormId } from 'Constants/HubSpot'
import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { useHubSpotFormLoader, useResponsiveLayout } from 'Hooks'

import { Container, FormHolder, ImageHolder } from './styles'

function SubmitScoreboardFormSection() {
  const { isDesktop } = useResponsiveLayout()

  const handleFormSubmitted = useCallback(() => {}, [])

  const { ref, loading } = useHubSpotFormLoader({
    formId: HubSpotFormId.SubmitScoreboard,
    onFormSubmitted: handleFormSubmitted,
  })

  return (
    <SectionContainer>
      <Row fullWidth justifyCenter px={LANDING_CONTENT_PX}>
        <Container>
          <Column alignCenter fullHeight fullWidth gap={7} py={12} spaceBetween>
            <SubsectionTitle centered title="Submit your Scorecard" />

            {loading && (
              <Column fullHeight justifyCenter>
                <Loader />
              </Column>
            )}

            <FormHolder id={HubSpotFormId.SubmitScoreboard} ref={ref} />
          </Column>

          {isDesktop && (
            <ImageHolder>
              <Image alt="" objectFit="cover" src={BackgroundImage} />
            </ImageHolder>
          )}
        </Container>
      </Row>
    </SectionContainer>
  )
}

export default SubmitScoreboardFormSection
